import { render, staticRenderFns } from "./ModalCustomerList.vue?vue&type=template&id=51da243f&scoped=true"
import script from "./ModalCustomerList.vue?vue&type=script&lang=js"
export * from "./ModalCustomerList.vue?vue&type=script&lang=js"
import style0 from "./ModalCustomerList.vue?vue&type=style&index=0&id=51da243f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51da243f",
  null
  
)

export default component.exports